import React from "react";
import { Outlet } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { LayoutDashboard, Users, Send, Settings } from "lucide-react";

const nav = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard, testid: "nav-admin-dashboard" },
  { to: "/admin/users", label: "Users", icon: Users, testid: "nav-admin-users" },
  { to: "/admin/payouts", label: "Payouts", icon: Send, testid: "nav-admin-payouts" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "nav-admin-settings" },
];

export default function AdminLayout() {
  return (
    <Shell nav={nav} portalLabel="Admin">
      <Outlet />
    </Shell>
  );
}
